import * as React from 'react';
import { Flex } from '../../../../../components/common/flex';
import { Call } from '../../../../../components/icons';
import { useResize } from '../../../../../hooks/use_resize';
import { IContactsInfoProps } from './contacts_info.d';

export const ContactsInfo: React.FC<IContactsInfoProps> = ({ responsibleName, responsiblePhone }) => {
  const { isExtraLargeScreen } = useResize();

  if (!responsibleName || !responsiblePhone) return;

  return isExtraLargeScreen ? (
    <Flex vertical className={'approve-book-section approve-book-section--contacts'}>
      <span>
        Если возникли вопросы или проблемы по подтверждению бронирования, Вы можете связаться с нами по номеру:
      </span>
        <Flex gap={6} align={'center'} component={'a'} href={`tel:${responsiblePhone}`}>
          <Call size={18} color={'#1e5bbe'} />
          <span>{responsiblePhone}</span>
        </Flex>
        <div>Ваш менеджер — {responsibleName}.</div>
      <div>Ежедневно с 10:00 до 19:00 (МСК).</div>
    </Flex>
  ) : (
    <Flex vertical className={'approve-book-section approve-book-section--contacts'}>
      <span>
        Если возникли вопросы или проблемы по подтверждению бронирования, Вы можете связаться с нами по номеру:
      </span>
        <Flex gap={6} align={'center'} component={'a'} href={`tel:${responsiblePhone}`}>
          <Call size={18} color={'#1e5bbe'} />
          <span>{responsiblePhone}</span>
        </Flex>
        <span>Ваш менеджер — {responsibleName}.</span>
      <div>Ежедневно с 10:00 до 19:00 (МСК).</div>
    </Flex>
  );
};
